// extracted by mini-css-extract-plugin
export default {"container":"Home_container__qRlyu","logo":"Home_logo__s21Dj","slogan":"Home_slogan__evT3d","title":"Home_title__1aNQh","intro-button":"Home_intro-button__l+HMA"};